import { render, staticRenderFns } from "./UserResetPasswordModal.vue?vue&type=template&id=bbd5fb22"
import script from "./UserResetPasswordModal.vue?vue&type=script&lang=js"
export * from "./UserResetPasswordModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports